<section class="hd-iching-cheat-sheet-page">
  <e-card2 class="hd-iching-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-iching-cheat-sheet-page__controls" aria-label="IChing cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <button
        type="button"
        class="hd-iching-cheat-sheet-page__section-toggle"
        [class.hd-iching-cheat-sheet-page__section-toggle--active]="showSecondSection()"
        [attr.aria-pressed]="showSecondSection()"
        (click)="toggleSecondSection()"
      >
        <i eIcon [icon]="showSecondSection() ? 'xmark' : 'clone'"></i>
        <span>{{ showSecondSection() ? '2de sectie verbergen' : '2de sectie toevoegen' }}</span>
      </button>

      <button
        type="button"
        class="hd-iching-cheat-sheet-page__section-toggle"
        [class.hd-iching-cheat-sheet-page__section-toggle--active]="compactCards()"
        [attr.aria-pressed]="compactCards()"
        (click)="toggleCompactCards()"
      >
        <i eIcon [icon]="compactCards() ? 'up-right-and-down-left-from-center' : 'down-left-and-up-right-to-center'"></i>
        <span>{{ compactCards() ? 'Grote kaarten' : 'Kleine kaarten' }}</span>
      </button>

      @if (showSecondSection()) {
        <e-segmented-toggle
          size="md"
          testId="iching-section-layout"
          groupLabel="Indeling tweede sectie"
          [options]="sectionLayoutOptions"
          [value]="sectionLayout()"
          (valueChange)="setSectionLayout($event)"
        ></e-segmented-toggle>
      }
    </div>
  </e-card2>

  <div
    class="hd-iching-cheat-sheet-page__sections"
    [class.hd-iching-cheat-sheet-page__sections--side]="showSecondSection() && sectionLayout() === 'side'"
  >
    <div class="hd-iching-cheat-sheet-page__section">
      <div class="hd-iching-cheat-sheet-page__gates" aria-label="Poorten">
        @for (gate of gates; track gate) {
          <button
            type="button"
            class="hd-iching-cheat-sheet-page__gate-button"
            [class.hd-iching-cheat-sheet-page__gate-button--active]="gate === selectedGate()"
            [attr.aria-pressed]="gate === selectedGate()"
            (click)="selectGate(gate)"
          >{{ gate }}</button>
        }
      </div>

      <div class="hd-iching-cheat-sheet-page__grid">
        @for (card of lineCards(); track card.lineNumber) {
          <hd-gate-line-card [viewModel]="card" [compact]="compactCards()" />
        }
      </div>
    </div>

    @if (showSecondSection()) {
      <div class="hd-iching-cheat-sheet-page__divider" aria-hidden="true"></div>

      <div class="hd-iching-cheat-sheet-page__section">
        <div class="hd-iching-cheat-sheet-page__gates" aria-label="Poorten (tweede sectie)">
          @for (gate of gates; track gate) {
            <button
              type="button"
              class="hd-iching-cheat-sheet-page__gate-button"
              [class.hd-iching-cheat-sheet-page__gate-button--active]="gate === selectedGate2()"
              [attr.aria-pressed]="gate === selectedGate2()"
              (click)="selectGate2(gate)"
            >{{ gate }}</button>
          }
        </div>

        <div class="hd-iching-cheat-sheet-page__grid">
          @for (card of lineCards2(); track card.lineNumber) {
            <hd-gate-line-card [viewModel]="card" [compact]="compactCards()" />
          }
        </div>
      </div>
    }
  </div>
</section>
